(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-conserve-suggestions"] && !Shopify.designMode) return;
  try {
    
function syncConserveSuggestions(){
  const tags=new URL(location.href).searchParams.getAll('filter.p.tag').flatMap(value=>value.split(',')).filter(value=>value.toLowerCase().startsWith('pais-'));
  document.querySelectorAll('[data-am-conserves]').forEach(section=>{
    let visible=0;
    section.querySelectorAll('.am-conserves-card').forEach(card=>{
      let productTags=[];
      try{productTags=JSON.parse(card.dataset.tags).map(value=>value.toLowerCase());}catch(error){}
      card.hidden=tags.length>0&&!tags.some(tag=>productTags.includes(tag.toLowerCase()));
      if(!card.hidden)visible++;
    });
    section.hidden=visible===0;
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncConserveSuggestions,{once:true});else syncConserveSuggestions();
document.addEventListener('shopify:section:load',syncConserveSuggestions);
window.addEventListener('popstate',syncConserveSuggestions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-country-persistent"] && !Shopify.designMode) return;
  try {
    
function mountCountryBanner(){
  const banner=document.querySelector('[data-am-country-banner]');
  const spacer=document.querySelector('[data-am-country-banner-space]');
  const header=document.getElementById('am-smart-header');
  const panel=document.getElementById('am-country-panel');
  const label=document.getElementById('am-country-selected-label');
  const form=document.getElementById('am-country-form');
  const main=document.getElementById('MainContent');
  if(!banner||!spacer||!header||!panel||!label||!form||!main||banner.dataset.ready)return;
  banner.dataset.ready='true';
  document.body.append(banner);
  main.prepend(spacer);
  const boxes=Array.from(form.querySelectorAll('[name="am-country"]'));
  const byHandle=new Map(boxes.map(box=>[box.value,box]));
  const codes={'mexico':'mx','honduras':'hn','el-salvador':'sv','guatemala':'gt','colombia':'co','puerto-rico':'pr','estados-unidos':'us','venezuela':'ve','peru':'pe','costa-rica':'cr','brasil':'br','chile':'cl','espana':'es','alemania':'de','francia':'fr','suiza':'ch','corea-del-sur':'kr','vietnam':'vn','tailandia':'th','china':'cn','paises-bajos':'nl','australia':'au','taiwan':'tw'};
  const categories=banner.querySelector('[data-am-country-banner-categories]');
  const seen=new Set();
  document.querySelectorAll('#am-category-strip .am-category-track>a[href]').forEach(source=>{
    const url=new URL(source.href,location.origin);
    if(seen.has(url.pathname))return;
    seen.add(url.pathname);
    const link=source.cloneNode(true);
    link.removeAttribute('id');
    categories.append(link);
  });
  let active=false;
  function measure(){
    if(!active)return;
    if(main.firstElementChild!==spacer)main.prepend(spacer);
    const bottom=Math.max(0,Math.round(header.getBoundingClientRect().bottom));
    banner.style.setProperty('--am-country-banner-header',bottom+'px');
    spacer.style.height=Math.ceil(banner.getBoundingClientRect().height)+'px';
  }
  function render(event){
    const applied=label.textContent.split(',').map(value=>value.trim());
    const state=event?.detail||{active:panel.classList.contains('am-country-active'),countries:boxes.filter(box=>applied.includes(box.dataset.label)).map(box=>box.value)};
    const selected=(state.countries||[]).filter(handle=>byHandle.has(handle));
    active=!!state.active&&selected.length>0;
    banner.hidden=spacer.hidden=!active;
    document.body.classList.toggle('am-country-banner-active',active);
    banner.querySelector('[data-am-country-banner-label]').textContent=selected.map(handle=>byHandle.get(handle).dataset.label).join(', ');
    banner.querySelector('.am-country-banner-message').title=banner.querySelector('[data-am-country-banner-label]').textContent;
    const flags=banner.querySelector('[data-am-country-banner-flags]');
    flags.replaceChildren();
    if(active){
      const first=selected[0];
      if(codes[first]){
        const image=document.createElement('img');
        image.src='https://flagcdn.com/w80/'+codes[first]+'.png';
        image.width=48;image.height=36;
        image.alt=byHandle.get(first).dataset.label;
        flags.append(image);
      }
      if(selected.length>1){const count=document.createElement('small');count.textContent='+'+(selected.length-1);flags.append(count);}
      categories.querySelectorAll('a').forEach(link=>{
        const url=new URL(link.href,location.origin);
        const other=url.searchParams.getAll('filter.p.tag').flatMap(value=>value.split(',')).filter(value=>!/^pais-/i.test(value));
        url.searchParams.delete('filter.p.tag');
        other.forEach(value=>url.searchParams.append('filter.p.tag',value));
        selected.forEach(handle=>url.searchParams.append('filter.p.tag',byHandle.get(handle).dataset.tag));
        url.searchParams.set('am_paises',selected.join(','));
        link.href=url.pathname+url.search;
      });
    }else spacer.style.height='0px';
    requestAnimationFrame(measure);
  }
  banner.querySelector('[data-am-country-banner-clear]').addEventListener('click',()=>document.getElementById('am-country-clear')?.click());
  document.addEventListener('americas:country-filter-change',render);
  new MutationObserver(()=>render()).observe(label,{childList:true,subtree:true});
  new ResizeObserver(measure).observe(header);
  new ResizeObserver(measure).observe(banner);
  window.addEventListener('resize',measure,{passive:true});
  window.addEventListener('pageshow',()=>render());
  render();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountCountryBanner,{once:true});else mountCountryBanner();
document.addEventListener('shopify:section:load',mountCountryBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-meat-suggestions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('am-meat-suggestions')){
  customElements.define('am-meat-suggestions',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('[data-meat-track]');
      this.previous=this.querySelector('[data-meat-prev]');
      this.next=this.querySelector('[data-meat-next]');
      if(!this.track||!this.previous||!this.next)return;
      this.previous.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
      this.track.addEventListener('keydown',event=>{
        if(event.target===this.track&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){
          event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);
        }
      },options);
      window.addEventListener('popstate',()=>this.syncCountries(),options);
      document.addEventListener('americas:country-filter-change',()=>this.syncCountries(),options);
      this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);
      this.syncCountries();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
    update(){
      const maximum=this.track.scrollWidth-this.track.clientWidth;
      this.previous.disabled=this.track.scrollLeft<=2;
      this.next.disabled=this.track.scrollLeft>=maximum-2;
      this.previous.hidden=this.next.hidden=maximum<=2;
    }
    move(direction){
      const card=[...this.track.children].find(item=>!item.hidden);
      const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;
      const distance=card?card.getBoundingClientRect().width+gap:this.track.clientWidth;
      this.track.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    syncCountries(){
      const url=new URL(location.href);
      const countries=url.searchParams.getAll('filter.p.tag').flatMap(value=>value.split(',')).filter(value=>value.toLowerCase().startsWith('pais-')).map(value=>value.toLowerCase());
      let visible=0;
      this.querySelectorAll('[data-meat-tags]').forEach(card=>{
        let tags=[];try{tags=JSON.parse(card.dataset.meatTags).map(value=>value.toLowerCase());}catch(error){}
        card.hidden=countries.length>0&&!countries.some(country=>tags.includes(country));
        if(!card.hidden)visible++;
      });
      this.hidden=visible===0;
      const link=this.querySelector('[data-meat-view-all]');
      const target=new URL(link.getAttribute('href'),location.origin);target.search='';
      countries.forEach(country=>target.searchParams.append('filter.p.tag',country));
      const preview=url.searchParams.get('preview_theme_id');if(preview)target.searchParams.set('preview_theme_id',preview);
      link.href=target.pathname+target.search;
      requestAnimationFrame(()=>this.update());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
